import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatMenuModule } from '@angular/material/menu';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { RouterModule } from '@angular/router';
import { NoResultsModule } from '@components';

import { SharedModule } from '../../shared.module';
import { CdsTooltipModule } from '../cds-tooltip/cds-tooltip.module';
import { PortfolioTableComponent } from './portfolio-table.component';

@NgModule({
  declarations: [PortfolioTableComponent],
  imports: [
    CommonModule,
    MatTableModule,
    MatSortModule,
    MatButtonModule,
    MatMenuModule,
    MatDividerModule,
    RouterModule,
    OverlayModule,
    CdsTooltipModule,
    SharedModule,
    NoResultsModule
  ],
  exports: [PortfolioTableComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PortfolioTableModule {}
